// frontend/src/components/layout/AdminLayout.js (نسخه صحیح)

import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import '../../assets/styles/global.css'; // اطمینان از لود شدن استایل‌ها

const AdminLayout = () => {
    return (
        <div className="app-layout">
            <Sidebar />
            <div className="main-content-wrapper">
                <Header />
                <main className="page-content">
                    {/* این Outlet به React Router می‌گوید که کامپوننت مسیر فرزند را اینجا رندر کند */}
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;